import PropTypes from "prop-types";
import { useState } from "react";
import Markdown from "solar/components/Markdown";
import Title from "components/shared/stays/Title";
import Text from "components/shared/stays/Text";
import Button from "solar/components/Button";
import Modal from "components/shared/stays/Modal";
import ModalBody from "components/shared/stays/ModalBody";
import Anchor from "solar/components/Anchor";
import PhotosGrid from "components/shared/stays/PhotosGrid";
import GalleryTwoUp from "components/shared/stays/GalleryTwoUp";
import SectionRhythm from "components/shared/stays/SectionRhythm";
import styles from "components/stay/Accommodation.module.scss";

export default function Accommodation({
  description,
  images,
  tripTypeDescription,
}) {
  const [showModal, setShowModal] = useState(false);
  const handleModalShow = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);

  const dynamicName =
    tripTypeDescription === "Boat" ? "Berths" : "Accommodation";

  return (
    <>
      <div className={styles.component}>
        <Anchor id="description" offset />
        <Title>{dynamicName}</Title>
        {images.length > 0 && (
          <SectionRhythm>
            <PhotosGrid
              photos={images}
              photoAlt={dynamicName}
              onClick={handleModalShow}
              inPage
            />
          </SectionRhythm>
        )}
        <SectionRhythm>
          <Text>
            <Markdown truncate>{description}</Markdown>
          </Text>
        </SectionRhythm>
        <SectionRhythm>
          <Button onClick={handleModalShow} ghost responsive>
            {"More about the "}
            {dynamicName.toLowerCase()}
          </Button>
        </SectionRhythm>
      </div>
      <Modal show={showModal} handleClose={handleModalClose}>
        <ModalBody>
          <Title>
            {"More about the "}
            {dynamicName.toLowerCase()}
          </Title>
          {images.length > 0 && (
            <GalleryTwoUp
              photos={images}
              photoAlt={dynamicName}
              showButton
              buttonText={`Show ${
                images.length
              } ${dynamicName.toLowerCase()} photos`}
            />
          )}
          <SectionRhythm>
            <Markdown>{description}</Markdown>
          </SectionRhythm>
        </ModalBody>
      </Modal>
    </>
  );
}

Accommodation.propTypes = {
  tripTypeDescription: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.shape({
        id: PropTypes.number,
        url: PropTypes.string,
      }),
    })
  ).isRequired,
};
